<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center justify-content-end">
        <Button
            icon-class="fas fa-backspace"
            iconColor="#989EA7"
            btn-class="btn-sm"
            type="cancel"
            btn-text="projectsTransferred.backToProjectList"
            @click="$router.push({ name: 'projects-index' })"/>
      </div>
    </template>
    <template #layoutContent>
      <Loader>
        <div class="row">
          <div class="col-12">
            <Card :title="$t('projectsTransferred.list')">
              <template #cardToolbar>
                <div class="d-flex">
                  <label class="form-label fs-6 text-black me-2 align-self-center mt-2"> {{ $t('projectsTransferred.from') }}: </label>
                  <ButtonDropdownFilter
                      :btn-title="$t('projectsTransferred.allUser')"
                      :options="[...users]"
                      value-field="id"
                      name-field="fullname"
                      v-model="query.from_user_id"
                  />
                  <label class="form-label fs-6 text-black me-2 align-self-center mt-2"> {{ $t('projectsTransferred.to') }}: </label>
                  <ButtonDropdownFilter
                      :btn-title="$t('projectsTransferred.allUser')"
                      :options="[...users]"
                      value-field="id"
                      name-field="fullname"
                      v-model="query.to_user_id"
                  />
                  <Button
                      type="new"
                      btn-class="btn-sm"
                      btn-text="projectsTransferred.transferProjectToUser"
                      @click.prevent="openTransferProjectModal" />
                </div>

              </template>
              <template #cardBody>
                <div class="p-3">
                  <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="projects_transferred_datatable">
                    <thead>
                    <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                      <th class="min-w-200px text-start">{{ $t('projectsTransferred.label.project') }}</th>
                      <th class="min-w-200px text-start">{{ $t('projectsTransferred.label.from') }}</th>
                      <th class="min-w-100px text-center">{{ $t('projectsTransferred.label.to') }}</th>
                      <th class="min-w-50px text-center">{{ $t('label.action') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="loading">
                      <td colspan="4" class="text-center">
                        <span class="spinner-border spinner-border-sm align-middle"></span>
                        {{ $t('loading') }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </Card>
          </div>
        </div>
      </Loader>

      <TransferProjectsToAnother id="open_transfer_project_form_modal" @callback="loadData" />

    </template>
  </SubLayout>
</template>
<script setup>

import Card from "@/components/Card.vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {useLocales} from "@/composables/locales";
import {computed, ref, watch, onMounted} from "vue";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import TransferProjectsToAnother from "./components/modals/TransferProjectsToAnother.vue"
import {useSwal} from "@/composables/useSwal";

const {showSwal} = useSwal()
const route = useRoute()
const router = useRouter()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()


const title = ref("breadcrumbs.projects.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.projects.list',
    route: 'projects-index'
  },
  {
    name: 'breadcrumbs.projects.transferredList',
    route: 'projects-transferred-index'
  }
])

const loading = ref(false)
const table = ref(null)
const restoring = ref(false)
const query = ref({
  from_user_id: '',
  to_user_id:''
})
const projects = ref([])


const users = computed(() => store.getters["user/getUsers"])


watch(query, (value) => {
  loadData(query.value)

}, { deep: true })


function openTransferProjectModal() {
  $('#open_transfer_project_form_modal').modal('toggle')
}
function loadData(query = null) {
  loading.value = true;

  store
      .dispatch("projectsTransferred/loadTransferredProject", query)
      .then((res) => {
        projects.value = res.data.transfer || [];

        if (table.value) {
          table.value.clear();
          table.value.destroy();
          table.value = null;
        }

        setTimeout(() => {
          table.value = $("#projects_transferred_datatable").DataTable({
            columns: [
              { data: 'projects' },
              { data: 'from_user' },
              { data: 'to_user' },
              { data: 'transfer_id' }
            ],
            columnDefs: [
              {
                targets: -4,
                order: "asc",
                className: "dt-start text-start clickable" ,
                render: function (t, a, e, l) {
                  let render = ''
                  if(t && t.length) {
                    t.forEach(projet => {
                      render += `<span class="badge badge-sm badge-primary mx-1"> ${projet.project_title} </span>`
                    })
                  }
                  return render;
                },
              },
              {
                targets: -3,
                order: "asc",
                className: "dt-start text-start clickable" ,
                render: function (t, a, e, l) {
                  return '<span data-id="'+ e.id +'">' + t + "</span>";
                },
              },
              {
                targets: -2,
                order: "asc",
                className: "dt-start text-start clickable" ,
                render: function (t, a, e, l) {
                  return '<span data-id="'+ e.id +'">' + t + "</span>";
                },
              },
              {
                targets: -1,
                order: "asc",
                className: "dt-start text-center clickable" ,
                render: function (t, a, e, l) {
                  let render = ''

                  render+='<a href="javascript:;" data-id="'+ t+'" style="cursor: pointer;" class="btn-danger btn btn-sm btn-clean btn-icon restore_btn" title="'+ i18n.global.t('projectsTransferred.label.restore') +'"><i  data-id="'+ t +'" class="bi bi-arrow-repeat fs-2"></i></a>'

                  return render;
                },
              },
            ],
            data: projects.value,
            layout: {
              bottomEnd: {
                paging: {
                  firstLast: false,
                },
              },
            },
            language: {
              url: datatableLocaleUrl.value,
            },
          });

          table.value.on("click", ".restore_btn", (e) => {
            const target = e.target.closest('.restore_btn');
            const id = target.getAttribute('data-id')
            restoreTransferredProject(id)
          });

        }, 50);
      })
      .finally(() => (loading.value = false));
}
function restoreTransferredProject(id) {
  showSwal(
      i18n.global.t('projectsTransferred.restore'),
      i18n.global.t('projectsTransferred.restore_text')
  ).then( async (result) => {
    if (result.value) {
      restoring.value = true
      store.dispatch('projectsTransferred/restoreTransferredProject', { transfer_id: id })
          .then(res => {
            loadData()
          })
          .finally(() => restoring.value = false)
    }
  })
}


onMounted(() => {
  loadData()
  store.dispatch("user/loadUsers");
})

</script>

<style scoped>
.table-container {
  height: 350px;
  overflow-y: auto;
}

thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 1;
}

@media (min-width:992px) {
  .class-h {
    height: 65px !important;
  }
}

@media (min-width:1200px) {
  .class-h {
    height: auto !important;
  }
}
</style>